module.exports = __webpack_public_path__ + "media/images/fbcalls_positive-1ffd95f9392de91ac4cda7f43c964a04.png";